const loginUI = {
  default: {
    fields: ["email", "password"],
  },
};

export default loginUI;
